/** Redirect URL for provider. */
export const redirectUri = [
  location.protocol,
  '//',
  location.host,
  '/login',
  '/redirect',
].join('');
